import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface ChangedMapping {
  businessUnitName: string;
  tradeName: string;
}

interface ConfirmTradeMappingsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSaving: boolean;
  changedMappings: ChangedMapping[];
}

const ConfirmTradeMappingsDialog: React.FC<
  ConfirmTradeMappingsDialogProps
> = ({ isOpen, onClose, onConfirm, isSaving, changedMappings }) => {
  return (
    <Dialog onOpenChange={(open) => !open && !isSaving && onClose()} open={isOpen}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader className="pb-2">
          <DialogTitle>Confirm Trade Mappings</DialogTitle>
        </DialogHeader>

        <div className="max-h-60 overflow-y-auto rounded-md border border-gray-200 dark:border-slate-700 px-4">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-200 dark:border-slate-700">
                <th className="py-3 pr-4 text-left font-medium text-gray-500 dark:text-slate-400">
                  Business Unit
                </th>
                <th className="py-3 text-left font-medium text-gray-500 dark:text-slate-400">
                  Trade
                </th>
              </tr>
            </thead>
            <tbody>
              {changedMappings.map((mapping, index) => (
                <tr
                  className="border-b last:border-b-0 border-gray-100 dark:border-slate-700/50"
                  key={index}
                >
                  <td className="py-3 pr-4 text-gray-900 dark:text-slate-100">
                    {mapping.businessUnitName}
                  </td>
                  <td className="py-3 text-gray-900 dark:text-slate-100">
                    {mapping.tradeName}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-2 flex items-start gap-2 rounded-md bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 p-3 text-sm text-yellow-700 dark:text-yellow-400">
          <AlertTriangle className="h-5 w-5 text-yellow-600 dark:text-yellow-400 flex-shrink-0 mt-0.5" />
          <span>
            <strong>This action cannot be reverted.</strong> Please review the
            following mapping changes before confirming.
          </span>
        </div>

        <DialogFooter className="pt-2">
          <Button disabled={isSaving} onClick={onClose} variant="outline">
            Cancel
          </Button>
          <Button disabled={isSaving} onClick={onConfirm}>
            {isSaving ? "Saving..." : "Confirm"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmTradeMappingsDialog;
